module.exports = __webpack_public_path__ + "c6f37d0208a6c93eba2525ad23a0db4e.svg";